<template lang="pug">
  app-modal(v-model="visible" :title="title" :width="1200" :confirm-loading="loading" @ok="handleSubmit" @cancel="hide")
    div.inventory_editor
      div.product_list.p1 
        div.mt1.mb1(style="font-weight: 600;") 下单产品信息
        div.head
          div.row
            div.name.p1 下单产品
            div.product_comments.p1 下单备注
            div.num.p1 下单数量
            div.actions.p1 操作
        div.body
          div.row
            div.name.p1 {{ model.productDTO ? model.productDTO.name : '' }} 
            div.product_comments.p1 {{ model.productComments || '--' }}
            div.num.p1 {{ model.quantity }}
            div.actions.p1 
              app-link-btn(v-if="!orignOrder.orderItems || !orignOrder.orderItems[index].productId" 
                @click="$refs.real.show(model)"
              ) 匹配产品
              span(v-else) -- 
      SelectRealProduct(ref="real" v-model="model.productDTO" @change="handleRealProduct")      
      a-form-model-item(label="" prop="inventoryId" )
      div.inventory_list.p1
        div.mt1.mb1(style="font-weight: 600;") 仓库信息
        app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="50")
          a-row(:gutter="16")
            a-col(:span="10")
              a-form-model-item(label="仓库" prop="warehouseId" )
                app-remote-select(v-model="model.warehouseId" 
                  api="/prj/warehouses/list" :params="params" 
                  allow-clear 
                  placeholder="请选择仓库"
                  @change="handleWarehouseChange"
                  )    
            a-col(:span="10")            
              a-form-model-item(label="分区" prop="warehousePartitionId" )
                app-remote-select(v-model="model.warehousePartitionId" 
                  api="/prj/warehouse-partitions/list" 
                  :params="{ projectId: project.id, warehouseId: model.warehouseId}" 
                  allow-clear 
                  placeholder="请选分区"
                  @change="handleWarehousePartChange"
                  ) 
        
        
        
</template>

<script>
import SelectRealProduct from './SelectRealProduct';
import AsyncBtn from '../Components/AsyncBtn';

import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
import _ from 'lodash';
export default {
  name: 'CreateAndEdit',
  components: { SelectRealProduct, AsyncBtn },
  props: {
    target: Object,
  },
  data() {
    return {
      visible: false,
      loading: false,
      title: '选择出库库存',
      model: {
        inventoryId: null,
        warehouseId: null,
        warehousePartitionId: null,
      },
      rules: {
        // inventoryId: [{ required: true, message: '必填项' }],
        warehouseId: [{ required: true, message: '必填项' }],
        warehousePartitionId: [{ required: true, message: '必填项' }],
      },
      tableColumns: [],
      index: 0,
      orignOrder: {},
      productId: null,
      // 可用库存
      inventoriesLoading: false,
      inventoryList: [],
      // 使用的库存
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
  },
  watch: {
    productId: 'loadInventories',
  },
  created() {
    // this.initTableColumns();
  },
  methods: {
    handleRealProduct(product) {
      this.model = {
        ...this.model,
        productId: product?.id,
        productName: product?.name,
      };
      this.productId = product?.id;
      // console.log({ ...this.model });
    },

    show(product, index) {
      // this.$refs.form.resetFields();
      this.index = index;
      this.orignOrder = _.cloneDeep(this.target);
      this.model = {
        ...this.model,
        ...this.orignOrder.orderItems[index],
      };
      this.visible = true;
    },
    hide() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.model = {
        warehouseId: null,
        warehouseName: null,
        warehousePartitionId: null,
        warehousePartitionName: null,
      };
      this.orignOrder = {};
      // this.$refs.item.handleCancel();
    },
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.loading = true;
        this.$restful(`POST:/prj/orders/item`, {
          ...this.model,
          productDTO: null,
        })
          .then((res) => {
            this.orignOrder.orderItems[this.index] = { ...this.model };
            this.$emit('change', { ...this.orignOrder });
            this.hide();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }, //(e) => model.warehousePartitionId = null
    handleWarehouseChange(val, option) {
      this.model.warehousePartitionId = null;
      const warehouse = option?.data?.attrs?.data;
      if (warehouse) {
        this.model.warehouseName = warehouse.name;
      }
    },
    handleWarehousePartChange(val, option) {
      const warehousePart = option?.data?.attrs?.data;
      if (warehousePart) {
        this.model.warehousePartitionName = warehousePart.name;
      }
    },
    // 初始化筛选条件
    initFilters() {
      this.filterFieleds = [];
    },
  },
};
</script>

<style lang="less" scoped>
.inventory_editor {
  width: 100%;
  gap: 16px;
  .product_list {
    flex: 1;
  }
  .inventory_list {
    flex: 2;
  }
  .head {
    background: rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
    .row div {
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }
  .body {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-top-width: 0;
    max-height: 160px;
    overflow: overlay;
  }
  .row {
    display: flex;
    & + .row {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
    .name {
      flex: 1;
      padding-left: 12px;
    }
    .num {
      width: 100px;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
    }
    .product_comments,
    .warehouse_name {
      flex: 1;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
    }
    .actions {
      width: 80px;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
  .row.sleected {
    color: #52c41a;
    font-weight: 600;
    background: #52c41a10;
  }
}
</style>
